import React, { Component, PropTypes } from 'react';

import Wrapper from 'components/wrapper';
import Badge from 'components/badge';
import TweenMax from 'gsap'

import styles from './styles.module.css';

export default class ProjectDescription extends Component {
  static propTypes = {
    children: PropTypes.node,
    media: PropTypes.node,
    appleUrl:PropTypes.string,
    appleGoogle:PropTypes.string,
  };
  componentWillUpdate (nextProps, nextState){

  }

  componentDidMount (prevProps, prevState){
  TweenMax.set(this.refs.badgeAnim, {y: 200})
    TweenMax.fromTo(this.refs.iphoneAnim, 3, {x: -1000}, {x: 0 , onComplete: () => {
      TweenMax.fromTo(this.refs.badgeAnim, 3, {y: 200}, {y: 0})
    }})


  }

  componentWillReceiveProps (nextProps) {

  }

  renderBadge(){
      if (this.props.googleUrl != null && this.props.appleUrl != null){
          return (<div ref="badgeAnim" className={styles.badge}>
                    <Badge
                      googlePlayUrl={this.props.googleUrl}
                      appleStoreUrl={this.props.appleUrl} />
                  </div>)
      }
  }

  render() {
    const { children, media } = this.props;

    return (
      <Wrapper className={styles.content}>
        <div onClick={()=> {
            TweenMax.to(this.refs.badgeAnim, 0.3, {scale: 1.2, repeat: 1,yoyo: true})}
          }
          ref="iphoneAnim"
          className={styles.media}>
          {media}
        </div>
        {this.renderBadge()}
        <div className={styles.information}>
          {children}
        </div>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ../components/project/description/index.jsx